module.exports = __webpack_public_path__ + "media/icon_transaction/dog_2-f801d529.png";